import * as Sentry from "@sentry/vue";
import { App } from '@vue/runtime-core';

export const setupSentry = ({app, enabled}: {app: App, enabled?: boolean}) => {
  Sentry.init({
    app,
    enabled,
    dsn: "https://b609b7970cdcbdc24516b6cee01c3ae4@o225249.ingest.sentry.io/4506592579223552",
    tracePropagationTargets: ['approval-gql.tts.dev'],
    integrations: [
       Sentry.browserTracingIntegration(),
       Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}